import React from "react";
import { Layout } from "antd";
import "./Footer.css";

const { Footer: AntFooter } = Layout;

const Footer: React.FC = () => {
  return (
    <AntFooter className="footer-container">
      <div className="footer-content">City of New Orleans 2025</div>
    </AntFooter>
  );
};

export default Footer;
